import { render } from "./HomePageV1.vue?vue&type=template&id=0211992e&scoped=true"
import script from "./HomePageV1.vue?vue&type=script&lang=js"
export * from "./HomePageV1.vue?vue&type=script&lang=js"

import "./HomePageV1.vue?vue&type=style&index=0&id=0211992e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0211992e"]])

export default __exports__